import { Subject } from 'rxjs';

const subject = new Subject();

export const InlineLoaderService = {
  loadStart: () => subject.next( 'kt-spinner kt-spinner--sm kt-spinner--success kt-spinner--right kt-spinner--input' ),
  clearLoading: () => subject.next(''),
  getLoading: () => subject.asObservable()
};